import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {Video, Section} from '../../../components';


export default function Workspace(props){
  let type=props.match.params.ss_name;
  let block=true; for(let wd of props.workspace.defaults){for(let ss of wd.special_services){if(ss.name==type){block=false;}}}

  if(block==true){window.location.href='/companies/table'; return null;}
  let videos=[{title:'Intro video', video:'MARKETING_PRL'},{title:'Scoring tutorial', video:'PRL_RETURN'}];

  if(type!=undefined){
    return(
      <Grid container style={{width:'100%', maxWidth:'1200px', marginTop:'-20px'}}>
      <Grid item xs={12} md={8}>
      <Section>
        <div style={{width:'90vw', maxWidth:'600px', height:'400px', marginTop:'30px', marginBottom:'30px'}}>
        <div><img style={{maxWidth:'300px', marginLeft:'10px', marginTop:'-10px'}} src='/images/icons/scoring_service_biggest.png'/></div>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>
        <Typography style={{fontWeight:"bold", marginTop:'20px'}}>Give yourself a <a href='https://prospectsafari.com/jumpstart/'>JumpStart</a>: </Typography>
        <div><Typography variant='caption' style={{marginLeft:'30px'}}> - <b>7x</b> your call connect rate</Typography></div>
        <div><Typography variant='caption' style={{marginLeft:'30px'}}> - <b>7x</b> more actual conversations per hour spent dialling</Typography></div>
        <div><Typography variant='caption' style={{marginLeft:'30px'}}> - Slash your cost per meeting and boost your Return on Sales Time (ROST).</Typography></div>
        <div><Typography style={{fontWeight:"bold", marginTop:'20px'}}>How does it work? </Typography></div>
        <div><Typography variant='caption' style={{marginLeft:'30px'}}> - Bulk select and request scoring of selected contacts</Typography></div>
        <div><Typography variant='caption' style={{marginLeft:'30px'}}> - We identify the best phone number & determine the likelihood of an answer</Typography></div>
        <div><Typography variant='caption' style={{marginLeft:'30px'}}> - You call only those likely to answer. Use email, social etc for the rest.</Typography></div>
        <div style={{marginTop:'20px'}}><Typography variant='caption'><b>Cost: $1 per contact</b> (up to 5 phone numbers each).</Typography></div>
        <div><Typography variant='caption'>Credits purchased in packs of 50.</Typography></div>
        <div><Typography variant='caption' style={{color:'red'}}>* Only numbers from north america are supported.</Typography></div>
        <div><Typography variant='caption'><a href='https://prospectsafari.com/jumpstart/'>Not convinced? Click here</a></Typography></div>
      </div></div></Section>
      <Section no_title no_padding><iframe style={{maxWidth:'800px', width:'100%', marginLeft:'-2px', border:'none', height:'calc(100vh - 70px)'}} src='/pdfs/JumpStart_scoring.pdf#zoom=80'/></Section></Grid>
      <Grid item xs={12} md={4} style={{height:'calc(100vh - 30px)', overflowY:'scroll'}}><Grid container style={{marginBottom:'20px'}}>{videos.map(function(v){
        return(<Grid item xs={12} sm={6} md={12}><Section title={v.title} top='-25px' no_padding><Video video={v.video} style={{width:'100%', marginBottom:'-5px', marginLeft:'-2px', height:'200px'}}/></Section></Grid>)
      })}</Grid></Grid>

      </Grid>
    )
  }

}
